<template>
  <Button class="op-btn" type="primary" @click="handleToBase">编辑</Button>
</template>
<script>
import { toBasePlatform } from '@/utils/utils.js';
export default {
  props: {
    // 要跳转到基础平台的页面(redirectUrl开头不要加斜杠/)
    redirectUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    // 打开新窗口跳转到基础平台页面
    handleToBase() {
      toBasePlatform(this.redirectUrl);
    }
  }
};
</script>
<style scoped>

</style>
